import {SUBLEAGUE_MESSAGES_SET, SUBLEAGUE_MESSAGES_HIDE, SUBLEAGUE_MESSAGE_SENT} from "./subleagueChatActions";

const DEFAULT_STATE = {
    show: false,
    messages: [],
    subleagueId: null
};

export const subleagueChatReducer = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SUBLEAGUE_MESSAGES_SET:
            return {
                ...state,
                show: true,
                ...action.payload
            };
        case SUBLEAGUE_MESSAGES_HIDE:
            return {
                ...DEFAULT_STATE,
                subleagueId: action.payload
            };
        case SUBLEAGUE_MESSAGE_SENT:
            return {
                ...state,
                messages: [...action.payload, ...state.messages]
            };
        default:
            return state;
    }
};